import Checkbox from './Checkbox'
import Radio from './Radio'
import Select from './Select'
import Switch from './Switch'
import TextField from './TextField'

export default {
  Checkbox,
  Radio,
  Select,
  Switch,
  TextField
}



// WEBPACK FOOTER //
// ./src/components/forms/index.js